import React, { useState, useEffect } from "react";
import { Grid, Container } from "@mui/material";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import CustomImageCard from "../../components/Custom/CustomImageCard";
import { useNavigate } from "react-router-dom";

export default function Lenders() {
  const { t } = useTranslation();
  const [lenders, setLenders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/lending/get-lender-list")
      .then((response) => {
        setLenders(response.data);
      })
      .catch((error) => {
        console.error("Error fetching lenders:", error);
      });
  }, []);

  const handleClick = (lenderId, lenderName) => {
    navigate(`/fpo/all-lenders/lenderId=${lenderId}?lenderName=${lenderName}`);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}
        >
          <CustomTitle>{t("All lenders")}</CustomTitle>

          {lenders.length !== 0 && (
            <div style={{ height: "90%", marginTop: "20px" }}>
              <Grid container spacing={1}>
                {lenders.map((lender) => (
                  <Grid item xs={12} key={lender.id}>
                    <CustomImageCard
                      image={lender.lender_logo}
                      name={lender.name}
                      onClick={() => handleClick(lender.id, lender.name)}
                    />
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
        </Grid>
      </Container>
    </>
  );
}
